'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'face-smile';
var width = 512;
var height = 512;
var aliases = [128578,"smile"];
var unicode = 'f118';
var svgPathData = ['M16 256a240 240 0 1 0 480 0 240 240 0 1 0 -480 0zm120.6 86.1c-2.7-3.5-2.1-8.5 1.3-11.2s8.5-2.1 11.2 1.3C174.1 363.7 212.7 384 256 384s81.9-20.3 106.8-51.8c2.7-3.5 7.8-4.1 11.2-1.3s4.1 7.8 1.3 11.2C347.6 377.3 304.4 400 256 400s-91.6-22.7-119.4-57.9zM192 208a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm160 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z', 'M496 256a240 240 0 1 0 -480 0 240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm149.2 76.2C174.1 363.7 212.7 384 256 384s81.9-20.3 106.8-51.8c2.7-3.5 7.8-4.1 11.2-1.3s4.1 7.8 1.3 11.2C347.6 377.3 304.4 400 256 400s-91.6-22.7-119.4-57.9c-2.7-3.5-2.1-8.5 1.3-11.2s8.5-2.1 11.2 1.3zM160 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFaceSmile = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;